import React, { HTMLAttributes, useCallback, useState } from 'react'
import { useRouter } from 'next/router'

import { Location } from '@services/api/locations'

import { SelectLocation } from './select-location'
import { SelectFranchise } from './select-company'
import { Button } from './button'
import { ListAndMapToggler } from './list-and-map-toggler'

import styles from './styles.module.scss'
import { useFranchise } from 'context/franchise'
import { FranchiseDto } from '@services/api/franchise/types'

export interface SearchData {
  location?: Location
  company?: FranchiseDto
  verified?: boolean
  workWithBV?: boolean
}

interface SearchProps extends HTMLAttributes<HTMLDivElement> {
  loading?: boolean
  onSearch?: (data: SearchData) => void
}

export const Search = ({
  onSearch,
  loading,
  ...rest
}: SearchProps): JSX.Element => {
  const { isMap, franchiseSelectedByMap, location } = useFranchise()
  const [form, setForm] = useState<SearchData>({
    company: franchiseSelectedByMap,
    location: location
  })

  const router = useRouter()

  const [routeChanging, setRouteChanging] = useState(false)

  const onSubmit = useCallback(() => {
    onSearch && onSearch(form)
  }, [onSearch, form])

  const HeaderSideBar = () => {
    const { name, state } = location || { name: undefined, state: undefined }
    let title = 'Lista de empresas de Energia Solar | Unidades Portal Solar'
    let description =
      'Explore as melhores empresas de energia solar e instaladores especializados do Portal Solar. Economize energia de maneira sustentável.'

    if (name) {
      title = `Lista de empresas de Energia Solar em ${name} | Unidades Portal Solar`
      description = `Você está procurando empresas de energia solar fotovoltaica para instalar painéis solares em ${name}? Veja as unidades Portal Solar em ${name} e solicite um orçamento grátis de instalação de placas solares em ${name}.`
    }

    if (state) {
      title = `Lista de empresas de Energia Solar em ${name} - ${state.name} | Unidades Portal Solar`
      description = `Você está procurando empresas de energia solar fotovoltaica para instalar painéis solares em ${name} - ${state.name}? Veja as unidades Portal Solar em ${name} - ${state.name} e solicite um orçamento grátis de instalação de placas solares em ${name} - ${state.name}.`
    }

    return (
      <div className="mb-4">
        <h1 className={styles.title}>{title}</h1>
        <h2>{description}</h2>
      </div>
    )
  }

  return (
    <div {...rest}>
      <HeaderSideBar />

      <ListAndMapToggler
        map={isMap}
        onClick={async button => {
          setRouteChanging(true)
          await router.push({
            query: { ...router.query, map: button !== 'list' ? 'on' : 'off' }
          })
          setRouteChanging(false)
        }}
      />
      <form>
        <div className={styles.select}>
          <label htmlFor="location">Procure por região</label>
          <SelectLocation
            value={form.location}
            onChange={location => {
              setForm({
                ...form,
                location
              })
            }}
          />
        </div>
        <div className={styles.select}>
          <label htmlFor="company">Ou procure por empresa</label>
          <SelectFranchise
            location={form.location}
            value={form.company}
            onChange={company =>
              setForm({
                ...form,
                company
              })
            }
          />
        </div>

        <Button
          title="Buscar"
          onClick={onSubmit}
          loading={loading || routeChanging}
        />
      </form>
    </div>
  )
}
